import userSettings from './user-settings'

// Add each local state item here
// Each local state item should have:
// resolvers
// defaults
// __typename
// typeDefs

const resolvers = {
  Mutation: {
    ...userSettings.resolvers.Mutation,
  },
}

const defaults = {
  userSettings: {
    __typename: userSettings.__typename,
    ...userSettings.defaults,
  },
}
const typeDefs = `${userSettings.typeDefs}`

const LocalState = {
  resolvers,
  defaults,
  typeDefs,
}

export default LocalState
